import { UPDATE_COUPON_EXPIRE_NUDGE_ALERT_ITEM } from 'yoda-checkout-components/lib/actionTypes/OutOfStockActionTypes';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { syncCouponExpireLSandPayload } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { UPDATE_LOW_STOCK_NUDGE_ALERT_ITEM } from '../actionTypes/CartActionTypes';

// PossibleState structure
/**
 * {
 *  lowStockInfo:{
 *      lowStockItems:[],
 *      isNudgeClosed: false,
 *  },
 *
 * }
 */
const defaultState = {
    lowStockInfo: {},
    // add coupons expiry Nudge Alert Info in future.
};
export default function NudgeAlertReducer(state = defaultState, action) {
    const { payload } = action;
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case UPDATE_LOW_STOCK_NUDGE_ALERT_ITEM:
            return {
                ...state,
                lowStockInfo: {
                    ...state.lowStockInfo,
                    ...payload,
                },
            };
        case UPDATE_COUPON_EXPIRE_NUDGE_ALERT_ITEM:
            // SYNC LS and Payload with nudgeCLosed for the session
            const { updatedCouponExpireData, updatedLsCouponData } = syncCouponExpireLSandPayload(
                payload?.couponsAboutToExpire
            );
            if (updatedLsCouponData.length > 0)
                LocalStorage.setData(
                    'couponExpireNudgeClosed',
                    JSON.stringify(updatedLsCouponData)
                );
            payload.couponsAboutToExpire = updatedCouponExpireData;
            return {
                ...state,
                couponExpireInfo: {
                    ...state.couponExpireInfo,
                    ...payload,
                },
            };
        default:
            return state;
    }
}
